import { useState } from "react";
import Button from '../components/Button.jsx'
import { ReplaceInviteLink } from '../repo/GroupsRepo.js';
import { config } from '../config';

export default function GroupManagementInvite({ invite }) {
  const buildInviteLink = (group_id, token) => {
    return config.baseUrl + "/groups/" + group_id + "/accept_invitation?token=" + token
  }

  const [inviteLink, setInviteLink] = useState(buildInviteLink(invite.group_id, invite.token));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [canReplaceInviteToday, setCanReplaceInviteToday] = useState(invite.count_created_today < 3);
  const [copyStatus, setCopyStatus] = useState("idle");

  const copyButtonHandler = () => {
    navigator.clipboard.writeText(document.getElementById('group-invite-link').textContent);
    setCopyStatus("shown");
    setTimeout(() => {
      setCopyStatus("fading");
      setTimeout(() => {
        setCopyStatus("idle");
      }, 500);
    }, 2000);
  }

  const handleReplaceInviteLinkResponse = (response) => {
    const token = response.token
    setInviteLink(buildInviteLink(invite.group_id, token))
  }

  const replaceInviteLinkButtonHandler = async () => {
    setIsSubmitting(true);
    ReplaceInviteLink(invite.group_id).then(
      response => {
        if (response.status === 423) {
          setCanReplaceInviteToday(false)
        } else {
          handleReplaceInviteLinkResponse(response.data)
        }
      }
    )
    setIsSubmitting(false);
  }

  return (
    <div className="flex flex-col">
      <h2 className="font-bold text-md mt-2 mb-4">Convite para o Bolão</h2>

      <div className="mb-6">
        <div className="flex flex-col space-y-2">

          {!isSubmitting && (
            <>
              <p id="group-invite-link" className="border border-black overflow-auto bg-white rounded-lg p-4">
                {inviteLink}
              </p>
              {copyStatus === "idle" && (
                <Button styleName="dark" className="w-[136px] p-4" onClick={copyButtonHandler} disabled={isSubmitting}>
                  Copiar
                </Button>
              )}
              {copyStatus !== "idle" && (
                <div className={`text-green-600 text-center h-[40px] transition-opacity duration-500 border border-green-600 p-2 w-[300px] rounded-lg ${copyStatus === "fading" ? "opacity-0" : "opacity-100"}`}>
                  Convite copiado com sucesso!
                </div>
              )}
            </>
          )}

          {isSubmitting && (
            <p>Processando...</p>
          )}

        </div>
      </div>

      <div className="mt-2">
        <div className="flex flex-col space-y-2">
          {canReplaceInviteToday && (
            <>

              <div id="alert-additional-content-4" className="w-full mx-auto p-4 m-8 text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300 dark:border-yellow-800" role="alert">
                <div className="flex items-center">
                  <svg className="shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                  </svg>
                  <span className="sr-only">Info</span>
                  <h3 className="text-lg font-medium">Atenção!</h3>
                </div>
                <div className="mt-2 mb-4 text-sm">
                  <span>O botão abaixo exclui o link do convite atual que não poderá mais ser usado, nem mesmo pelas pessoas que já o possuem. Porém, um outro será gerado automaticamente e poderá ser usado normalmente, caso seja compartilhado. Esta operação só poderá ser realizada 3 vezes por dia.</span>
                </div>

                <div className="flex">
                  <button onClick={replaceInviteLinkButtonHandler} disabled={isSubmitting} type="button" className="text-white bg-yellow-800 hover:bg-yellow-900 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-xs px-3 py-1.5 me-2 text-center inline-flex items-center dark:bg-yellow-300 dark:text-gray-800 dark:hover:bg-yellow-400 dark:focus:ring-yellow-800">
                    Substituir convite
                  </button>
                </div>
              </div>

            </>
          )}
          {!canReplaceInviteToday && (
            <span className="text-red-500">Não é possível recriar o convite para o Bolão hoje. Sua quota do dia foi atingida, tente amanhã.</span>
          )}
        </div>
      </div>

    </div>
  )
}
